import type { ShortsFilters } from '~/core/entities/property/filters';

const NUMERIC_FILTER_KEYS: (keyof ShortsFilters)[] = [
	'minAskingPrice',
	'maxAskingPrice',
	'minArea',
	'maxArea'
];
const STRING_ARRAY_FILTER_KEYS: (keyof ShortsFilters)[] = [
	'propertyTypes',
	'cities',
	'regions',
	'macroregions'
];

export class ShortsFiltersPresenter {
	static sanitizeNumeric(value: number | null | undefined): number | null {
		return value && !isNaN(value) ? value : null;
	}

	static sanitizeStringArray<T extends string>(
		arr: T[] | null | undefined
	): T[] | undefined {
		return arr && arr.length > 0 ? arr : undefined;
	}

	static isValueApplied(val: unknown): boolean {
		if (Array.isArray(val)) return val.length > 0;
		if (typeof val === 'number') return !isNaN(val) && val > 0;
		return val !== undefined && val !== null && val !== '';
	}

	static toShortsFilters(rawFilters: Record<string, unknown>): ShortsFilters {
		const result: Record<string, unknown> = {};
		NUMERIC_FILTER_KEYS.forEach(key => {
			result[key] = this.sanitizeNumeric(rawFilters[key] as number);
		});
		STRING_ARRAY_FILTER_KEYS.forEach(key => {
			result[key] = this.sanitizeStringArray(
				rawFilters[key] as string[] | undefined
			);
		});
		return result as ShortsFilters;
	}
}
